import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { verifySignatureFailed, verifySignatureSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* verifySignature(action) {
  try {
    const url = `${BACKEND_URL}/proxy/backend/api/v2/applications/${action.payload}/verify-signature`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(verifySignatureSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(verifySignatureFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(verifySignatureFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
